import {injectable} from 'inversify';

import {UserAdditionalDataModel} from './UserAdditionalData.model';

@injectable()
export class UserAdditionalDataFactory {
  create(props: UserAdditionalDataModel.Props): UserAdditionalDataModel {
    return new UserAdditionalDataModel(props);
  }
}
